'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SearchResults = require('./SearchResults');

var _SearchResults2 = _interopRequireDefault(_SearchResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchResults2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SearchResults/index.js
// module id = 647
// module chunks = 11